import { __assign } from "tslib";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// Misc
export var dropFirstTimeNoticeFlag = createAction(actionKey + ".CHAT_DROP_FTUE_FLAG", function () { return ({}); });
// Dynamic redux
export var reduxModuleLoaded = createAction(actionKey + ".CHAT_REDUX_READY", function () { return ({}); });
// Local storage
export var hydrateDBInit = createAction(actionKey + ".CHAT_LS_HYDRATE_INIT", function (chatAuthToken) { return ({
    chatAuthToken: chatAuthToken,
}); });
export var hydrateDBChats = createAction(actionKey + ".CHAT_LS_HYDRATE_CHATS", function (openChatroomsOrder, chatrooms) { return ({
    openChatroomsOrder: openChatroomsOrder,
    chatrooms: chatrooms,
}); });
export var hydrateDBChatListCache = createAction(actionKey + ".CHAT_LS_HYDRATE_CHATLIST_CACHE", function (chats) { return ({
    chats: chats,
}); });
export var hydrateDBChatListRequestsCache = createAction(actionKey + ".CHAT_LS_HYDRATE_CHATLIST_REQUESTS_CACHE", function (chats) { return ({
    chats: chats,
}); });
export var setChatAuthToken = createAction(actionKey + ".CHAT_CACHE_TOKEN", function (token) { return ({ token: token }); });
// Main chat actions
export var chatOnline = createAction(actionKey + ".CHAT_ONLINE", function () { return ({}); });
export var chatOffline = createAction(actionKey + ".CHAT_OFFLINE", function (error) { return ({
    error: error,
}); });
export var setPageType = createAction(actionKey + ".CHAT_PAGETYPE", function (type) { return ({
    type: type,
}); });
export var openChatPanel = createAction(actionKey + ".CHAT_OPEN_CHATPANEL", function () { return ({}); });
export var closeChatPanel = createAction(actionKey + ".CHAT_CLOSE_CHATPANEL", function () { return ({}); });
// Worker
export var chatWorkerReady = createAction(actionKey + ".CHAT_WORKER_READY", function () { return ({}); });
export var setChatWorker = createAction(actionKey + ".CHAT_SET_WORKER", function (worker) { return ({ worker: worker }); });
export var setChatWorkerStatus = createAction(actionKey + ".CHAT_SET_WORKER_STATUS", function (status) { return ({ status: status }); });
export var chatStartIdle = createAction(actionKey + ".CHAT_START_IDLE", function () { return ({}); });
export var chatEndIdle = createAction(actionKey + ".CHAT_END_IDLE", function () { return ({}); });
export var chatStartWake = createAction(actionKey + ".CHAT_START_WAKE", function () { return ({}); });
export var chatWorkerStartupIfNeeded = createAction(actionKey + ".CHAT_WORKER_STARTUP", function (isInit) { return ({ isInit: isInit }); });
export var setChatWorkerIdleStatus = createAction(actionKey + ".CHAT_SET_IDLE_STATUS", function (idle) { return ({ idle: idle }); });
// Global unreads
export var globalUnreadCountSubscribe = createAction(actionKey + ".UNREAD_COUNT_SUB", function () { return ({}); });
export var globalUnreadCountUnSubscribe = createAction(actionKey + ".UNREAD_COUNT_UNSUB", function () { return ({}); });
export var globalUnreadCountUpdated = createAction(actionKey + ".UNREAD_COUNT_UPDATE", function (data) { return data; });
// Chatlist
export var chatListSubscribe = createAction(actionKey + ".CHATLIST_SUB", function () { return ({}); });
export var chatListUnsubscribe = createAction(actionKey + ".CHATLIST_UNSUB", function () { return ({}); });
export var chatListSuccess = createAction(actionKey + ".CHATLIST_SUCCESS", function (sub) { return ({ sub: sub }); });
export var chatListError = createAction(actionKey + ".CHATLIST_ERROR", function (error) { return ({ error: error }); });
export var chatListUpdated = createAction(actionKey + ".CHATLIST_UPDATED", function (data) { return (__assign({}, data)); });
export var chatListFetchMore = createAction(actionKey + ".CHATLIST_FETCHMORE", function () { return ({}); });
export var setActiveChatListTab = createAction(actionKey + ".CHATLIST_SET_TAB", function (index) { return ({ index: index }); });
// Chat Requests
export var chatRequestsSubscribe = createAction(actionKey + ".CHAT_REQUESTS_SUB", function () { return ({}); });
export var chatRequestsUnsubscribe = createAction(actionKey + ".CHAT_REQUESTS_UNSUB", function () { return ({}); });
export var chatRequestsSubscribeSuccess = createAction(actionKey + ".CHAT_REQUESTS_SUBSCRIBE_SUCCESS", function (sub) { return ({ sub: sub }); });
export var chatRequestsSubscribeError = createAction(actionKey + ".CHAT_REQUESTS_SUBSCRIBE_ERROR", function (error) { return ({ error: error }); });
export var chatRequestsUpdated = createAction(actionKey + ".CHAT_REQUESTS_UPDATED", function (data) { return (__assign({}, data)); });
export var chatRequestsFetchMore = createAction(actionKey + ".CHAT_REQUESTS_FETCH_MORE", function () { return ({}); });
export var acceptChatRequest = createAction(actionKey + ".ACCEPT_CHAT_REQUEST", function (chatroomId) { return ({ chatroomId: chatroomId }); });
// Chatrooms
export var chatroomSubscribe = createAction(actionKey + ".CHAT_SUB", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var chatroomSubscriptionStarted = createAction(actionKey + ".CHAT_SUB_START", function (chatroomId, sub) { return ({ chatroomId: chatroomId, sub: sub }); });
export var chatroomInitialFetched = createAction(actionKey + ".CHAT_SUB_INIT_FETCHED", function (chatroomId, room) { return ({ chatroomId: chatroomId, room: room }); });
export var chatroomChanged = createAction(actionKey + ".CHAT_SUB_ONCHANGE", function (chatroomId, room) { return ({ chatroomId: chatroomId, room: room }); });
export var fetchChatroomParticipants = createAction(actionKey + ".FETCH_CHAT_PARTICIPANTS", function (chatroomId) { return ({
    chatroomId: chatroomId,
}); });
export var chatroomParticipantsFetched = createAction(actionKey + ".CHAT_PARTICIPANTS_FETCHED", function (chatroomId, participants) { return ({
    chatroomId: chatroomId,
    participants: participants,
}); });
export var chatroomError = createAction(actionKey + ".CHAT_SUB_ERROR", function (chatroomId, error) { return ({ chatroomId: chatroomId, error: error }); });
export var chatroomUnsubscribe = createAction(actionKey + ".CHAT_UNSUB", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var toggleOverlayChatList = createAction(actionKey + ".TOGGLE_OVERLAY_CHAT_LIST", function () { return ({}); });
export var finishFocusingInputField = createAction(actionKey + ".FINISH_FOCUSING_INPUT_FIELD", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var switchToChatroomInOverlayOverflow = createAction(actionKey + ".SWITCH_TO_CHATROOM_IN_OVERLAY_OVERFLOW", function (overflowStartIndex, chatroomId) { return ({
    overflowStartIndex: overflowStartIndex,
    chatroomId: chatroomId,
}); });
export var openOrSwitchToChatroom = createAction(actionKey + ".OPEN_OR_TOGGLE_CHATROOM", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var openChatroom = createAction(actionKey + ".OPEN_CHATROOM", function (chatroomId) { return ({ chatroomId: chatroomId }); });
/**
 * Opens a chatroom at the end of desktop's chatbar stack.
 *
 * Useful if we need to open a new chatroom without messing with the user's already open chatrooms.
 */
export var openChatroomAtEndOfStack = createAction(actionKey + ".OPEN_CHATROOM_AT_END_OF_STACK", function (chatroomId) { return ({ chatroomId: chatroomId }); });
/** Closes a chat window and cleans up its subscription */
export var closeChatroom = createAction(actionKey + ".CLOSE_CHATROOM", function (chatroomId) { return ({ chatroomId: chatroomId }); });
/** Toggles between `ChatWindowMode.DEFAULT` and `ChatWindowMode.MINIMIZED`. For the floating chat windows on desktop */
export var toggleChatroomWindow = createAction(actionKey + ".TOGGLE_CHATROOM_WINDOW", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var changeChatroomWindowMode = createAction(actionKey + ".CHANGE_CHATROOM_WINDOW_MODE", function (chatroomId, mode) { return ({ chatroomId: chatroomId, mode: mode }); });
export var addNewChatParticipant = createAction(actionKey + ".ADD_NEW_CHAT_PARTICIPANT", function (participant) { return ({ participant: participant }); });
export var removeNewChatParticipant = createAction(actionKey + ".REMOVE_NEW_CHAT_PARTICIPANT", function (participant) { return ({ participant: participant }); });
export var clearNewChatWindowParticipants = createAction(actionKey + ".CLEAR_NEW_CHAT_WINDOW_PARTICIPANTS", function () { return ({}); });
/**
 * Starts our new chat creation process and sets up a message to be sent upon creation.
 *
 * `requestId` is a temporary id that you provide so we can manage multiple new chat requests at the same time.
 *
 * Refer to the Chat README for context on why we need to handle multiple requests.
 */
export var createNewChatroom = createAction(actionKey + ".CREATE_NEW_CHATROOM", 
// createAction + typescript really doesn't like us adding an optional argument here,
// so I removed the typings
function (requestId, message) { return ({
    requestId: requestId,
    message: message,
}); });
export var retryCreateNewChatroom = createAction(actionKey + ".RETRY_CREATE_NEW_CHATROOM", function (requestId) { return ({ requestId: requestId }); });
export var failCreatingNewChatroom = createAction(actionKey + ".FAIL_CREATING_NEW_CHATROOM", function (requestId, error, errorKey) { return ({
    requestId: requestId,
    error: error,
    errorKey: errorKey,
}); });
export var createChatWithUser = createAction(actionKey + ".CREATE_CHAT_WITH_USER", function (requestId, source, user, message) { return ({
    requestId: requestId,
    source: source,
    user: user,
    message: message,
}); });
/**
 *
 */
export var createOrOpenChatWithUser = createAction(actionKey + ".CREATE_OR_OPEN_CHAT_WITH_USER", function (requestId, user) { return ({
    requestId: requestId,
    user: user,
}); });
export var createOrOpenChatAndSend = createAction(actionKey + ".CREATE_OR_OPEN_CHAT_AND_SEND", function (requestId, user, message) { return ({
    requestId: requestId,
    user: user,
    message: message,
}); });
/**
 * Starts our new chat creation process using the participants from an existing chat.
 *
 * `requestId` is a temporary id that you provide so we can manage multiple new chat requests at the same time.
 *
 * Note: Currently we don't add users to an ongoing chat, we create a new chat with the new users
 * This may change. The UX isn't clear and we've heard several different things.
 */
export var createGroupChatFromDirectMessage = createAction(actionKey + ".CREATE_GROUP_CHAT_FROM_DIRECT_MESSAGE", function (requestId, chatroomId) { return ({ requestId: requestId, chatroomId: chatroomId }); });
export var addParticipantToChatUserInput = createAction(actionKey + ".ADD_PARTICIPANT_TO_CHAT_USER_INPUT", function (chatroomId, participant) { return ({
    chatroomId: chatroomId,
    participant: participant,
}); });
export var removeParticipantFromChatUserInput = createAction(actionKey + ".REMOVE_PARTICIPANT_FROM_CHAT_USER_INPUT", function (chatroomId, participant) { return ({
    chatroomId: chatroomId,
    participant: participant,
}); });
export var clearParticipantsFromChatUserInput = createAction(actionKey + ".CLEAR_PARTICIPANTS_FROM_CHAT_USER_INPUT", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var initializeNewChatroom = createAction(actionKey + ".INITIALIZE_NEW_CHATROOM", function (requestId, chatroomId) { return ({ requestId: requestId, chatroomId: chatroomId }); });
/** Handles clean up of any left over after a successful `initializeNewChatroom` */
export var finalizeNewChatroom = createAction(actionKey + ".FINALIZE_NEW_CHATROOM", function (requestId) { return ({ requestId: requestId }); });
export var openNewChatWindow = createAction(actionKey + ".OPEN_NEW_CHAT_WINDOW", function (requestId) { return ({ requestId: requestId }); });
export var closeNewChatWindow = createAction(actionKey + ".CLOSE_NEW_CHAT_WINDOW", function (requestId) { return ({ requestId: requestId }); });
export var beginSetupOfNewChatWithParticipant = createAction(actionKey + ".BEGIN_SETUP_OF_NEW_CHAT_WITH_PARTICIPANT", function (requestId, participant) { return ({
    requestId: requestId,
    participant: participant,
}); });
export var startNewChatWithParticipant = createAction(actionKey + ".START_NEW_CHAT_WITH_PARTICIPANT", function (requestId, participant) { return ({
    requestId: requestId,
    participant: participant,
}); });
export var leaveChatroom = createAction(actionKey + ".LEAVE_CHATROOM", function (chatroomId, users, needsConfirmation) { return ({
    chatroomId: chatroomId,
    users: users,
    needsConfirmation: needsConfirmation,
}); });
export var blockChatParticipant = createAction(actionKey + ".BLOCK_CHAT_PARTICIPANT", function (user, chatroomId) { return ({
    user: user,
    chatroomId: chatroomId,
}); });
/** Clean up after a successful `leaveChatroom` action */
export var finishLeavingChatroom = createAction(actionKey + ".FINISH_LEAVING_CHATROOM", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var errorLeavingChatroom = createAction(actionKey + ".ERROR_LEAVING_CHATROOM", function (chatroomId, error) { return ({ chatroomId: chatroomId, error: error }); });
export var deleteChatroom = createAction(actionKey + ".DELETE_CHATROOM", function (chatroomId, needsConfirmation) { return ({
    chatroomId: chatroomId,
    needsConfirmation: needsConfirmation,
}); });
export var renameChatroom = createAction(actionKey + ".RENAME_CHATROOM", function (chatroomId, name) { return ({ chatroomId: chatroomId, name: name }); });
export var signalNewMsg = createAction(actionKey + ".NEW_MSG_SIGNAL", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var queueChatroomScrollEvent = createAction(actionKey + ".SCROLL_CHATROOM", function (chatroomId, scrollEvent) { return ({
    chatroomId: chatroomId,
    scrollEvent: scrollEvent,
}); });
export var clearChatroomScrollEvent = createAction(actionKey + ".CLEAR_CHATROOM_SCROLL_EVENT", function (chatroomId) { return ({ chatroomId: chatroomId }); });
/** Pull all the participants that have been added to a group chat's user input and try to add them to the current chat  */
export var addParticipantsToGroupChat = createAction(actionKey + ".ADD_PARTICIPANTS_TO_GROUP_CHAT", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var finishAddingParticipantsToGroupChat = createAction(actionKey + ".FINISH_ADDING_PARTICIPANTS_TO_GROUP_CHAT", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var watchChatParticipant = createAction(actionKey + ".WATCH_CHAT_PARTICIPANT", function (username) { return ({ username: username }); });
export var removeGroupChatParticipant = createAction(actionKey + ".REMOVE_GROUP_CHAT_PARTICIPANT", function (chatroomId, participantId) { return ({ chatroomId: chatroomId, participantId: participantId }); });
export var finishRemovingGroupChatParticipant = createAction(actionKey + ".FINISH_REMOVING_GROUP_CHAT_PARTICIPANT", function (chatroomId, participantId) { return ({ chatroomId: chatroomId, participantId: participantId }); });
export var errorRemovingGroupChatParticipant = createAction(actionKey + ".ERROR_REMOVING_GROUP_CHAT_PARTICIPANT", function (chatroomId, error) { return ({ chatroomId: chatroomId, error: error }); });
export var initializeChatroomModeManage = createAction(actionKey + ".INITIALIZE_CHATROOM_MODE_MANAGE", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var finalizeChatroomModeManage = createAction(actionKey + ".FINALIZE_CHATROOM_MODE_MANAGE", function (chatroomId, participants) { return ({
    chatroomId: chatroomId,
    participants: participants,
}); });
export var refreshChatListSubscription = createAction(actionKey + ".REFRESH_CHAT_LIST_SUBSCRIPTION", function () { return ({}); });
export var refreshChatroomSubscription = createAction(actionKey + ".REFRESH_CHATROOM_SUBSCRIPTION", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var sendDroppedDeviation = createAction(actionKey + ".SEND_DROPPED_DEVIATION", function (chatroomId, deviation) { return ({ deviation: deviation, chatroomId: chatroomId }); });
export var sendDeviationByDirectMessage = createAction(actionKey + ".SEND_DEVIATION_BY_DIRECT_MESSAGE", function (user, deviation) { return ({ deviation: deviation, user: user }); });
export var cacheChatroomScrollPosition = createAction(actionKey + ".CACHE_CHATROOM_SCROLL_POSITION", function (chatroomId, scrollPosition) { return ({
    chatroomId: chatroomId,
    scrollPosition: scrollPosition,
}); });
export var setNewMessageArrived = createAction(actionKey + ".NEW_MESSAGE_ARRIVED", function () { return ({}); });
/**
 * Brings an open chatroom to the front of desktop's chatbar.
 */
export var bringChatroomToFrontOfStack = createAction(actionKey + ".BRING_CHATROOM_TO_FRONT_OF_STACK", function (chatroomId) { return ({ chatroomId: chatroomId }); });
export var setFooterHeight = createAction(actionKey + ".SET_FOOTER_HEIGHT", function (height, chatId) { return ({ height: height, chatId: chatId }); });
export var startRealtimeListener = createAction(actionKey + ".REALTIME_START", function () { return ({}); });
export var stopRealtimeListener = createAction(actionKey + ".REALTIME_STOP", function () { return ({}); });
/**
 * Fired whenever we receive a message in any chatroom, regardless of if it was open at the time.
 *
 * Dispatched via `@wix/chat-sdk`'s `chatEventEmitter`
 */
export var receivedRealtimeMessage = createAction(actionKey + ".RECEIVED_REALTIME_MESSAGE", function (data) { return ({ data: data }); });
/**
 * Adds a chatroom id to a list of ids that we'll send to the `chat/shouldopenroom` endpoint.
 *
 * Fired whenever we see a new realtime message event and the chatroom fits some critera.
 */
export var addChatroomToNextShouldOpenRequest = createAction(actionKey + ".ADD_CHATROOM_TO_NEXT_SHOULD_OPEN_REQUEST", function (chatroomId) { return ({
    chatroomId: chatroomId,
}); });
/**
 * Clears the list of batched ids that we have already sent to the `chat/shouldopenroom` endpoint.
 */
export var clearShouldOpenRequestIds = createAction(actionKey + ".CLEAR_SHOULD_OPEN_REQUEST_IDS", function () { return ({}); });
export var clearSdk = createAction(actionKey + ".SDK_CLEAR", function () { return ({}); });
//# sourceMappingURL=actions.js.map